import router from './index.js'

router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    if (!to.name) return next({
        name: '404'
    })

    next();
})

router.afterEach(() => {
    document.documentElement.scrollTop = 0; // 重置滚动条高度
})